import { isPositiveNumber } from "../../../../helpers";
import { TValidator } from "../../../wizard/types";

export function validateOtherFeesGroup(otherFees, groupName, errors) {
  (otherFees || []).forEach((otherFee, index) => {
    if (otherFee?.name?.trim()) {
      if (!otherFee.amount?.trim()) {
        errors[groupName][index] = { amount: "Amount is required" };
      } else if (!isPositiveNumber(otherFee.amount)) {
        errors[groupName][index] = { amount: "Amount is invalid" };
      } else if (otherFee.amount.trim().split(".")[1]?.length > 2) {
        errors[groupName][index] = {
          amount: "Max 2 digits allowed after decimal point",
        };
      }
    }

    if (otherFee?.amount?.trim()) {
      if (!otherFee.name?.trim()) {
        if (errors[groupName][index]) {
          errors[groupName][index].name = "Name is required";
        } else {
          errors[groupName][index] = { name: "Name is required" };
        }
      }
    }
  });
}

export function validateAmountAndType(
  amount,
  amountName,
  type,
  typeName,
  errors,
) {
  if (amount?.trim()) {
    if (!isPositiveNumber(amount)) {
      errors[amountName] = "Amount is not valid";
    } else if (amount.trim().split(".")[1]?.length > 2) {
      errors[amountName] = "Max 2 digits allowed after decimal point";
    }

    if (!type) {
      errors[typeName] = "Type is required";
    }
  }

  if (type) {
    if (!amount?.trim()) {
      errors[amountName] = "Amount is required";
    } else if (type?.name === "Percent" && +amount > 100) {
      errors[amountName] = "Enter less than 100";
    }
  }
}

const deactivateFormValidator: TValidator = async ({ values }) => {
  const errors: { [key: string]: any } = {};
  const {
    injectedData: { approved, pending },
  } = values;
  const isReasonRequired = approved + pending > 0;

  if (isReasonRequired && !values.reason?.trim()) {
    errors.reason = "Reason is required";
  }

  if (Object.keys(errors).length > 0) {
    throw errors;
  }
};

export default deactivateFormValidator;
